import { IconProps } from "@/types/components/icons";

export function MenuIcon(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3024_7581" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3024_7581)">
        <path
          d="M2.91602 14.6954V13.4456H12.0827V14.6954H2.91602ZM2.91602 10.625V9.37498H17.0827V10.625H2.91602ZM2.91602 6.55436V5.30457H17.0827V6.55436H2.91602Z"
          fill={props.color || "#FFF"}
        />
      </g>
    </svg>
  );
}
